import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { de } from "date-fns/locale";
import { formatISO, isValid, parse } from "date-fns";

interface PdfRegenerationPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (date: string) => void;
  isLoading?: boolean;
}

export const PdfRegenerationPopup: React.FC<PdfRegenerationPopupProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleConfirm = () => {
    if (selectedDate && isValid(selectedDate)) {
      const isoDateString = formatISO(selectedDate);
      onConfirm(isoDateString);
    }
  };

  const handleClose = () => {
    setSelectedDate(null);
    onClose();
  };

  const isConfirmDisabled =
    !selectedDate || !isValid(selectedDate) || isLoading;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="pdf-regeneration-dialog-title"
    >
      <DialogTitle id="pdf-regeneration-dialog-title">
        PDF neu generieren
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Wählen Sie ein Datum für die PDF-Regenerierung:
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
            <DatePicker
              label="Datum auswählen"
              value={selectedDate}
              onChange={handleDateChange}
              format="dd.MM.yyyy"
              slotProps={{
                actionBar: {
                  actions: ["clear", "accept"],
                },
                textField: {
                  fullWidth: true,
                  variant: "outlined",
                  size: "small",
                },
              }}
              sx={{
                width: "100%",
              }}
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Button onClick={handleClose} variant="outlined" disabled={isLoading}>
          Abbrechen
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={isConfirmDisabled}
          sx={{
            backgroundColor: "#3f51b5",
            "&:hover": {
              backgroundColor: "#303f9f",
            },
          }}
        >
          {isLoading ? "Wird generiert..." : "Bestätigen"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
